import { type UseQueryResult, useQuery } from 'react-query';
import {
  RsuAwardService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_UpcomingVestingGrantsDto,
} from '@wealthlane/api-services/wealthlane-award-service';
import { type TableParamsType } from '../../types/common';

const useGetUpcomingRsuVestingList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_UpcomingVestingGrantsDto | undefined,
  unknown
> => {
  const { sorting, skipCount, maxResultCount, filter } = tableInfo;
  const upcomingRsuVestingList = useQuery(
    ['getUpcomingRsuVestingList', sorting, skipCount, maxResultCount, filter],
    async () => {
      return await handleRequest(
        RsuAwardService.getApiAwardApiAppRSUAwardUpcomingVestingGrants(
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return upcomingRsuVestingList;
};

export default useGetUpcomingRsuVestingList;
